

export const timeZoneConversion = (utcDateTimeString) => {
    if (utcDateTimeString.slice(-1) != 'Z') utcDateTimeString = utcDateTimeString + "Z";
    const utcDateTime = new Date(utcDateTimeString);

    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: browserTimeZone,
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
    });

    const browserDateTimeString = formatter.format(utcDateTime);
    return browserDateTimeString;
};


export const dateConversion = (utcDateTimeString) => {
    if (utcDateTimeString.slice(-1) != 'Z') utcDateTimeString = utcDateTimeString + "Z";
    const utcDateTime = new Date(utcDateTimeString);

    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: browserTimeZone,
        day: "numeric",
        month: "short",
        year: "numeric",
    });

    const browserDateTimeString = formatter.format(utcDateTime);
    return browserDateTimeString;
};


export const formatedTime = (timeInSecond) => {
    let hr = Math.floor(timeInSecond / 3600);
    let min = Math.floor((timeInSecond % 3600) / 60);
    let sec = Math.floor(timeInSecond % 60);

    return `${hr}:${min > 9 ? min : `0${min}`}:${sec > 9 ? sec : `0${sec}`}`;
};

